<template>
    <div>
      <v-container>
    
       <v-row>
   
         <v-col cols="12">
                   <v-card elevation="1">
                  <v-toolbar elevation="0">
                    <v-icon left color="primary">mdi-folder-multiple-outline</v-icon> Inventory  <v-divider vertical inset class="ml-5 mr-2"/>
                    <v-btn text small color="success"  @click="state='new', form=true">
                      <v-icon small left color="success">mdi-plus</v-icon>Add
                    </v-btn>
                    <v-spacer/>
                    <span style="width: 290px;">
                           <v-text-field
                               v-model="search"
                               append-icon="mdi-magnify"
                               label="Search"
                               single-line
                               dense
                               outlined
                               hide-details
                           ></v-text-field>
                    </span>
                  
                  </v-toolbar>
                  <v-card-text  v-if="items.length">
                  <table class="va-table va-table-border-bot">
                     <tr>
                        <th width="30"></th>
                        <th width="60">Image</th>
                        <th width="20%">Name</th>
                        <th width="30%">Description</th>
                        <th>Category</th>
                        <th>Tags</th>
                        <th>Status</th>
                        <th>Added On</th>
                     </tr> 
                     <tr v-for="(item, index) in FILTEREDITEMS" :key="index">
                        <td class="text-center">
                          <v-icon small @click="selectedID=item.id,state='modify',form=true">mdi-text-box-edit</v-icon></td>
                        <td>
                            <img :src="imagePreview(item.images)" width="90%"/>
                        </td>
                        <td>
                            {{item.name}}
                        </td>
                        <td> {{item.description}}</td>
                        <td> {{item.type}}</td>
                        <td>
                          <v-chip-group
                                column
                                multiple
                              >
                                <v-chip
                                  small
                                  outlined
                                  label
                                  color="primary"
                                  v-for="(tag, t) in item.tags" :key="t"
                                >
                                {{tag}}
                                </v-chip>
                            </v-chip-group>
                        </td>
                        <td> {{item.status}}</td>
                        <td> {{$moment(item.added_on).format("YYYY-MM-DD HH:MM A")}}</td>
                     </tr>
                    
                  </table>
                 
                    <div class="pa-4">
                          <span class="mx-2">Item(s) Found: {{SEARCHFILTER.length}}</span>|
                          <span class="mx-2">
                            Rows per page: <select v-model="view.per_page" @change="view.current_page=1"  class="va-select">
                              <option v-for="fruit in [5,10,15,20,50,100,1000]" :key="fruit" :value="fruit">
                                {{ fruit }}
                              </option>
                            </select>
                          </span>
                          |
                            <span class="mx-2">
                            <v-icon left small @click="view.current_page>1?view.current_page=view.current_page-1:view.current_page=1">mdi-arrow-left</v-icon>
                            {{view.current_page}}/{{ PAGE_COUNT}}
                            <v-icon right small @click="view.current_page<PAGE_COUNT?view.current_page=view.current_page+1:view.current_page=PAGE_COUNT">mdi-arrow-right</v-icon>
                             </span>   
                    </div>
                     
                  </v-card-text>
                  <v-card-text class="text-center" v-else>
                          <div class="font-weight-thin font-italic pa-5 mt-5"  >
                            <a  @click="state='new', form=true">Add your first product...  <v-icon  right small color="primary">mdi-pencil</v-icon></a>
                          </div>
                    </v-card-text>
             
                </v-card>
             </v-col>
       </v-row>
       </v-container>
        <va-inventory-form :show="form" :selectedID="selectedID"  :state="state" @DialogEvent="formEvent" />
     </div>
   </template>
   <script>
   import {
     mapMutations
   } from 'vuex'
     export default {
       data: () => ({
           form: false,
           search:"",
           selectedID:  null,
           trans_dailog: false,
           areaform: false,
           state: 'new',
           invetory:{},
           items:[],
           view: {
              per_page: 50,
              current_page: 1,
              pagination: true
           }
       }),
       beforeCreate: function () {
         if (!this.$session.exists()) {
           this.$router.push('/')
         }
       },
       created() {
          if (this.$session.exists()) {
             this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
             this.setLoggedIn(true) 
              this.CHECKPAGEPERMISSION()
             this.SETVARS()
            this.getItems()
           }
       },
       computed:{
         FILTEREDITEMS(){
            if(this.items.length == 0) {
              return []
            }
            var pageArr = this.$pagination(this.SEARCHFILTER,this.view.per_page)
            return pageArr[this.view.current_page - 1]
         },
         PAGE_COUNT(){
          var pageArr = this.$pagination(this.SEARCHFILTER,this.view.per_page)
          return pageArr.length
         },
         SEARCHFILTER(){
            if(this.search != "") {
              return this.$crawler(this.items, this.search)
            } else {
              return this.items
            }
         }
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
       
        imagePreview(images){
          console.log("images",images)
         if(images == null) {
          return  this.$store.state.nopreview
         }
           if(images.length == 0) {
          return  this.$store.state.nopreview
         }
         let arr = this.ViewUploadedfiles(images)
         return arr[0]
        },
         formEvent(){
             this.form = false
             this.getItems()
         },
   
         getItems: function() { 
          this.VA_ALERT('info', 'Loading products', 'progress', 100, 1500)
           this.GET_PRODUCTS((res)=>{
            console.log(res.status)
              this.invetory=res
              if(res.status) {
                this.items = res.results
              }
              
            })
        }
       }
     }
   </script>